var path = '/templates/projects.campaigns/views/directives/segment_condition_table_vertical.html';
var html = "<span class=\"label label-default\" ng-if=showTitle>{{segments.name}}</span><table class=\"table table-condenced\"><tr ng-repeat=\"header in headers\"><td class=detail-box>{{header}}</td><td class=detail-box>{{getSegmentHeader(segments, header) | segmentValueFormat}}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.campaigns/views/directives/segment_condition_table_vertical.html
// module id = 1397
// module chunks = 0